module.exports = __webpack_public_path__ + "img/reels.9e9ff06a.png";